(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ContractExistingController', ContractExistingController);

    ContractExistingController.$inject = ['$scope','ExistingContractDTO','XLSXExportService','AlertService','$uibModal','Principal'];

    function ContractExistingController($scope, ExistingContractDTO, XLSXExportService, AlertService, $uibModal, Principal) {
        var vm = this;

        vm.contracts = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'contractDate';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.initFilter = initFilter;
        vm.downloadReport = downloadReport;

        vm.filterModel = {};
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.contractDateFrom = {
            opened: false
        };
        $scope.contractDateTo = {
            opened: false
        };
        $scope.openContractDateFrom = function() {
            $scope.contractDateFrom.opened = true;
        };
        $scope.openContractDateTo = function() {
            $scope.contractDateTo.opened = true;
        };
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.contractDateFrom = false;
        vm.datePickerOpenStatus.contractDateTo = false;

        vm.fieldsMapping = {};
        vm.getContractFieldName = function(dtoName) {
            return vm.fieldsMapping[dtoName] || dtoName;
        };

        vm.gridOptions = {
            paginationPageSizes: [10,25,50,75,100],
            paginationPageSize: 100,
            enableFiltering: false,
            enabeGridMenu: true,
            enableRowSelection: true,
            enableSelectAll: false,
            showGridFooter: true,
            useExternalPagination: true,
            onRegisterApi: function(gridApi) {
                gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
                    if(sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = vm.getContractFieldName(sortColumns[0].field);
                        vm.reverse = sortColumns[0].sort.direction === 'asc';
                    } else {
                        vm.predicate = 'id';
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                {name: 'Contract #', field: 'contractNum', width: 200, visible:true},
                {name: 'Date', field: 'contractDate', width: 100, visible:true},
                {name: 'Type', field: 'contractType', width: 100, visible:true},
                {name: 'Buyer', field: 'buyer', width: 100, visible:true},
                {name: 'Seller', field: 'seller', width: 100, visible:true},
                {name: 'CropYear', field: 'cropYear', width: 100, visible:true},
                {name: 'Status', field: 'status', width: 100, visible:true},
                {name: 'Category', field: 'category', width: 105, visible:true},
                {name: 'S.Category', field: 'subCategory', width: 100, visible:true},
                {name: 'To Invoice Bales', field: 'uninvoicedQtyBales', width: 130, visible:true},
                {name: 'To Invoice MTs', field: 'uninvoicedGrossMts', width: 135, visible:true},
                {name: 'C.Unit Type', field: 'qtyUnitType', width: 110, visible:true},
                {name: 'C.Bales', field: 'qtyBales', width: 100, visible:true},
                {name: 'C.MTs', field: 'qtyMts', width: 100, visible:true},
                {name: 'Invoiced Bales', field: 'invoiceQtyBales', width: 130, visible:true},
                {name: 'Invoiced MTs', field: 'invoicedGrossMts', width: 130, visible:true}
            ]
        };

        initFilter();
        loadAll();

        function initFilter() {
            vm.filterModel = {
                showMe: true,
                contractNum: '',
                contractType: '',
                contractDateFrom: new Date('2017-01-01'),
                contractDateTo: new Date('2019-03-31'),
                draft: false,
                issued: true,
                complete: false,
                cancelled: false,
                categoryTui: true,
                categoryJapan: true,
                subCategoryJapan: true,
                subCategoryOutside: true,
                subCategoryPurchase: true,
                subCategoryDirect: true
            }
        }

        function loadAll() {
            if(vm.gridOptions) {
                vm.gridOptions.data = [];
            }
            vm.contracts = [];
            var queryParams = {
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            };
            queryParams = Object.assign({}, queryParams, vm.filterModel);

            ExistingContractDTO.query(queryParams, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc':'desc')];
                if(vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                for(var i = 0; i < data.length; i++) {
                    vm.contracts.push(data[i]);
                }
                vm.gridOptions.data = vm.contracts;
                vm.gridOptions.totalItems = headers('X-Total-Count');
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function downloadReport() {
            var reportParams = Object.assign(vm.filterModel);
            XLSXExportService.downloadExistingContractsReport(reportParams).then(function(data, status, headers, config) {
                var file = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                saveAs(file, "ExistingContractReport.xls");
            }, function(error) {
                ToastrService.error("Failed to Download Report","Error");
            });
        }

        function reset() {
            vm.page = 0;
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear() {
            vm.contracts = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        vm.cleanFilter = function() {
            initFilter();
            vm.reset();
        }

    }
})();
